var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"rules":[_vm.rule],"label":_vm.label,"suffix":"CHF"},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }